<template>
  <VTooltip v-if="helpLines.length > 0" class="v-icon-help" reference-style="display: inline-flex">
    <VIcon :class="iconClass" :icon :size :type />

    <template #content>
      <div class="v-icon-help-content">
        <div v-for="(line, index) in helpLines" :key="index" v-text="line" />
      </div>
    </template>
  </VTooltip>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { VIconIcon, VIconType } from '../types.ts'
import VIcon from './Icon/VIcon.vue'
import VTooltip from './VTooltip.vue'

interface Props {
  help?: string | string[]
  icon?: VIconIcon
  iconClass?: any
  size?: number
  type?: VIconType
}

const props = withDefaults(defineProps<Props>(), {
  help: '',
  icon: 'QuestionCircle',
  iconClass: undefined,
  size: 11,
  type: 'black',
})

const helpLines = computed(() => {
  if (Array.isArray(props.help)) {
    return props.help
  }

  if (props.help.length > 0) {
    return [props.help]
  }

  return []
})
</script>

<style>
.v-icon-help {
  text-align: left;
  display: inline-flex;
}

.v-icon-help-content {
  max-width: 400px;
  word-wrap: break-word;
}
</style>
